import React from 'react';
import { Text } from '@amzn/storm-ui';
import { Bar, BAR_STATE, BAR_STATE_STYLE } from '../types';
import { ProgressIndicatorAttribute } from '@amzn/storm-ui-page-header';
import { mapBarStateToStormProgressIndicatorVariant } from 'src/features/header/components/PageHeader/utils';

const getBarStatusWithTargetLine = (
  percentage: number,
  state: BAR_STATE | undefined,
  targetLine: number | undefined,
) => {
  if (state) return mapBarStateToStormProgressIndicatorVariant(state);
  if (targetLine && percentage < targetLine) return BAR_STATE_STYLE.ERROR;
  return BAR_STATE_STYLE.DEFAULT;
};

export const AttributesBar: React.VFC<Bar> = ({
  id,
  label,
  content,
  percentage,
  targetLine,
  tooltipText,
  tooltipPosition,
  state,
}) => {
  return (
    <ProgressIndicatorAttribute
      id={id}
      value={percentage}
      prefixLabel={label}
      label={() => <>{content}</>}
      status={getBarStatusWithTargetLine(percentage, state, targetLine)}
      targetLine={targetLine}
      helptipText={
        Array.isArray(tooltipText) ? (
          <>
            {tooltipText.map((label) => (
              <Text key={label}>{label}</Text>
            ))}
          </>
        ) : (
          tooltipText
        )
      }
      helptipTextPosition={tooltipPosition}
      data-ccx-e2e-id={`aac-attribute-${id}`}
    />
  );
};
